import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

const navbarHeight = 70 // 50px for navbar, plus 20 for padding

export default class extends Controller {
  initialize () {
    if (!window.smoothScroll) window.smoothScroll = new SmoothScroll()
  }

  scrollTo (event) {
    const anchor = document.querySelector(this.element.hash)
    event.preventDefault()
    window.smoothScroll.animateScroll(anchor, this.element, {
      offset: navbarHeight
    })
  }
}
